var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 28.5,
    stroke: "#179CF0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 19.75V31H40.5V21.25L33 16L25.5 21.25V23.5H22.5V19.75L33 12.25L43.5 19.75ZM35.25 20.5H33.75V22H35.25V20.5ZM32.25 20.5H30.75V22H32.25V20.5ZM35.25 23.5H33.75V25H35.25V23.5ZM32.25 23.5H30.75V25H32.25V23.5ZM40.5 34H37.5C37.5 32.2 36.375 30.58 34.695 29.95L25.455 26.5H13.5V43H22.5V40.84L33 43.75L45 40V38.5C45 36.01 42.99 34 40.5 34ZM16.5 40V29.5H19.5V40H16.5ZM32.955 40.615L22.5 37.72V29.5H24.915L33.645 32.755C34.155 32.95 34.5 33.445 34.5 34C34.5 34 31.515 33.925 31.05 33.775L27.48 32.59L26.535 35.44L30.105 36.625C30.87 36.88 31.665 37.015 32.475 37.015H40.5C41.085 37.015 41.61 37.36 41.85 37.855L32.955 40.615Z",
    fill: "#179CF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.2f6528c4b1e4baecb72c084850a608e9.svg";
export { ForwardRef as ReactComponent };